import instance from '../utils/axios';

class eleContractService {

    async getList(pageIndex,customerId) {
        return await instance.post('/oa/elesignController/getContractListInfo', {
			staffId: customerId,
			contractTypeId: 2,
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field":"数量","expression":"count(1)"}]',
            sortField: 'creationTime',
            sort: 'desc'
        });
    }
	async signContract(customerId) {
	    return await instance.get('/oa/elesignController/signContract?userType=2&contractTypeId=2&uuid=' + customerId);
	}
	async checkContract(flowId) {
	    return await instance.get('/oa/elesignController/getContractResult?flowId=' + flowId);
	}
	async downloadContract(flowId) {
	    return await instance.get('/oa/elesignController/downloadContract?flowId=' + flowId);
	}

}

export default new eleContractService();